import { Component, Vue } from 'vue-property-decorator';
import './break-induction.component.scss';
import DetailMessageModal from '@/common/components/detail-message-modal/detail-message-modal';
import AppConstants from '@/common/constants/app.constants';
import { namespace } from 'vuex-class';
import LoadingComponent from '@/common/components/loading/loading.component';
import InductionService from '@/common/service/induction.service';
import { SettingStoreConst } from '@/common/store/setting.store';

const AlertMessageStore = namespace('AlertMessageStore');
const SettingStore = namespace(SettingStoreConst.SETTING_STORE_MODULE_NAME);

@Component({})
export default class BreakInductionComponent extends Vue {
  inductionService = new InductionService();
  isLoading = false;

  @AlertMessageStore.Getter
  errorMessageArray!: Array<string>;

  @SettingStore.Getter
  restoreScreen!: string;

  /**
   * インダクションを開く。
   */
  async onOpenInduction() {
    try {
      this.isLoading = true;
      await this.inductionService.changeInductionStatus(false, this.restoreScreen);
    } catch {
      return null;
    } finally {
      this.isLoading = false;
    }
  }

  render() {
    return (
      <div
        class="break-induction-container"
        // 身長: (100% - (ヘッダ + ヘッダー行) -  (エラーメッセージがある場合 - 50))
        style={{
          height: `calc(${100}vh - ${68}px - ${this.errorMessageArray.length > 0 ? 50 : 0}px`
        }}
      >
        <LoadingComponent isActive={this.isLoading} />
        <div class="break-induction-icon">
          <span class="icon icon-break-induction-svg"></span>
        </div>
        <div class="break-induction-title">インダクション閉鎖中</div>
        <div class="break-induction-description">
          「仕分け再開」ボタンをタップするまではロボットがインダクション（投入口）に到着しません。
        </div>
        <div class="break-induction-button">
          <button onClick={() => this.onOpenInduction()}>仕分け再開</button>
        </div>
        <DetailMessageModal
          title="詳細メッセージ"
          idModal={AppConstants.DETAIL_ERROR_MESSAGE_ID_MODAL}
          errorMsg={this.errorMessageArray[0] || ''}
        />
      </div>
    );
  }
}
